module.exports = "<div class=\"{prefixCls}\">\n    {#if showTime}\n        <a class=\"{prefixCls}__time\" href=\"javascript:;\"\n           is-dis={timeDisabled}\n           on-click={this.onToggleTime()}>{isTime ? '选择日期' : '选择时间'}</a>\n    {/if}\n\n    <kl-button title=\"确认\" size=\"sm\" type=\"primary\" on-click={this.onSuccess()} />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLDate/base/confirm/index.html
// module id = 469
// module chunks = 0